import clsx from 'clsx';
import { type ReactElement, useCallback, useEffect, useState } from 'react';

import { Checkbox } from '~components/generic/elements';
import { type FieldSettings, type FieldValue } from '~modules/jsm-contact/shared/types';

type FormFieldProps = {
  fieldSettings: FieldSettings;
  fieldValue: FieldValue | FieldValue[];
  error?: string | null;
  onValueChanged: (key: string, value: FieldValue | FieldValue[]) => void;
  isSubmitting: boolean;
};

export const CheckboxGroup = ({
  fieldSettings,
  fieldValue,
  error,
  onValueChanged,
  isSubmitting,
}: FormFieldProps): ReactElement | null => {
  const [values, setValues] = useState<FieldValue[]>();

  useEffect(() => {
    onValueChanged(fieldSettings.name, values ?? []);
  }, [onValueChanged, fieldSettings.name, values]);

  const onChange = useCallback(
    (checked: boolean, key: FieldValue) => {
      if (checked) {
        if (values === undefined) {
          setValues([key]);
        } else if (!values.includes(key)) {
          const arr = values.slice();
          arr.push(key);
          setValues(arr);
        }
      } else {
        setValues(values === undefined ? [] : values.filter(item => item !== key));
      }
    },
    [values],
  );

  if (!fieldSettings.options) {
    return null;
  }

  return (
    <div className={clsx(error && 'border-e-red-20')}>
      {fieldSettings.options.map((option, key) => {
        const label = option.label !== undefined ? String(option.label) : '';

        return (
          <div key={key}>
            <Checkbox
              label={label}
              // id={`${fieldSettings.name}_${key}`}
              name={fieldSettings.name}
              value={fieldValue === option.value || (Array.isArray(fieldValue) && fieldValue.includes(option.value))}
              // defaultValue={
              //  fieldSettings.defaultValue === option.value ||
              //  (Array.isArray(fieldSettings.defaultValue) && fieldSettings.defaultValue.includes(option.value))
              // }
              disabled={isSubmitting}
              required={fieldSettings.required}
              onChange={(checked: boolean) => onChange(checked, option.value)}
              className={clsx('py-sm-1', error && 'error')}
            />
          </div>
        );
      })}
    </div>
  );
};
